let _ = require('lodash');
let { monkey } = require('baobab');
const COMPONENTS = require('../../compositions/auth');

module.exports = {
    /**
     * Устанавливаем компоненты специфичные для определенной вкладки
     * @param {Object} state
     */
    setComponentsByPage (state) {
        state.set(['page', 'components'], monkey(
            ['page', 'name'],
            (page) => _.get(COMPONENTS, page)
        ));
    },

    computeCountryDropdown (state, basePath) {
        state.set(basePath.concat(['computed', 'countryDropdown']), monkey(
            basePath.concat(['countries']),
            basePath.concat(['form', 'countryId']),
            (countries = [], selectedCountryId) => {
                let header = null;
                let isDisabled = false;

                let options = _.map(countries, (country) => ({
                    isActive: Number(selectedCountryId) === country.id,
                    title: country.name,
                    value: country.id
                }));

                // если пользователь не выбран
                if (_.every(options, ['isActive', false])) {
                    header = 'Выберите страну';
                }

                return { options, header, isDisabled };
            }
        ));
    },

    /**
     * Устанавливаем поле с email и password которое ввел пользователь (регистрация, логин, восстановление пароля)
     * @param {Object} state
     */
    setUserDataEmail (state) {
        // FIXME это может выстрелить, если пользователь ввле loginEmail с опечаткой и оказалось, что он не зареган,
        // тогда он перейдет на регистрацию и там уже введет другой email, а показывать мы будет первый
        state.set(['auth', 'computed', 'userData', 'email'], monkey(
            ['login', 'form', 'email'],
            ['registration', 'form', 'email'],
            ['restore', 'form', 'email'],
            (loginEmail, registerEmail, restoreEmail) => loginEmail || registerEmail || restoreEmail
        ));

        // FIXME не используется, зачем это?
        state.set(['auth', 'computed', 'userData', 'password'], monkey(
            ['login', 'form', 'password'],
            ['registration', 'form', 'password'],
            ['restore', 'form', 'password'],
            (loginPassword, registerPassword, restorePassword) => loginPassword || registerPassword || restorePassword
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/auth/index.js